import styled from 'styled-components';
import { isMobile } from 'utils/is-mobile';

export const ResultTitle = styled.div`
  font-size: ${isMobile() ? '18px' : '24px'};
  font-weight: 600;
  line-height: 1.2;
  padding-bottom: ${isMobile() ? '8px' : '12px'};
  color: var(--v3-primary-5);
`;

export const ResultSubTitle = styled.div`
  width: 308px;
  max-width: 100%;
  margin: 0 auto;
  text-align: center;
  font-size: 14px;
  font-weight: 400;
  color: var(--v3-black-65);
  line-height: 1.5;
`;
